/**
 * Trend-related constants and configuration
 */

import { TrendingUp, TrendingDown, Minus, LucideIcon } from "lucide-react";
import type { TrendDirection } from "@/types/security";

export interface TrendConfig {
  Icon: LucideIcon;
  color: string;
}

/**
 * Configuration mapping for trend directions
 */
export const TREND_CONFIG: Record<TrendDirection, TrendConfig> = {
  up: { Icon: TrendingUp, color: "text-red-600" },
  down: { Icon: TrendingDown, color: "text-green-600" },
  flat: { Icon: Minus, color: "text-gray-600" },
} as const;
